import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ENVIRONMENT } from '@env/environment';
import { Region } from '@regions/models/region';

@Injectable()
export class RegionsService {
  readonly #httpClient = inject(HttpClient);

  readonly #apiUrl = `${ENVIRONMENT.coreApi.endpoint}/regions`;

  list(): Observable<Region[]> {
    return this.#httpClient.get<Region[]>(`${this.#apiUrl}/list`);
  }
}
